export default "__VITE_ASSET__dkk3X0Nf__"